export enum ETipoSelecaoProduto {
    Consulta = 1,
    SelecaoUnica = 2,
    SelecaoMultipla = 3,
    SelecaoQuantidade = 4,
    SelecaoRastreabilidadeUnica = 5,
}
